export default __webpack_public_path__ + "static/media/heart.22312a8c.png";